/* `color` is set inline to the metric token; everything inherits currentColor. */
.wrap {
  position: relative;
  flex-shrink: 0;
}

/* Fills its container; the SVG is drawn at the measured width */
.wrap[data-fluid] {
  flex-shrink: 1;
  width: 100%;
  min-width: 0;
}

.svg {
  display: block;
  overflow: visible;
  cursor: crosshair;
  outline: none;
  border-radius: var(--radius-sm);
}

.svg:focus-visible {
  box-shadow: 0 0 0 2px var(--active-muted);
}

.line {
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  vector-effect: non-scaling-stroke;
}

.guide {
  stroke: var(--border-strong);
  stroke-width: 1;
  vector-effect: non-scaling-stroke;
}

.dot {
  fill: currentColor;
  stroke: var(--bg-base);
  stroke-width: 2;
}

/* d360's readout: near-black box, value in the metric colour over the quarter */
.tip {
  position: absolute;
  bottom: calc(100% + var(--space-3));
  transform: translateX(-50%);
  z-index: var(--z-flyout, 50);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  min-width: 96px;
  padding: var(--space-2) var(--space-3);
  background: var(--bg-base);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-lg);
  pointer-events: none;
  white-space: nowrap;
  animation: tipIn var(--duration-fast) var(--ease-default);
}

.tipValue {
  font-family: var(--font-display);
  font-size: 22px;
  line-height: 1;
  letter-spacing: 0.02em;
  color: currentColor;
}

.tipLabel {
  font-family: var(--font-display);
  font-size: 15px;
  line-height: 1;
  letter-spacing: 0.03em;
  color: var(--text-secondary);
}

@keyframes tipIn {
  from {
    opacity: 0;
    translate: 0 4px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .tip {
    animation: none;
  }
}
